import { render, staticRenderFns } from "./CompanyClassification.vue?vue&type=template&id=cd2ea8d6&scoped=true"
import script from "./CompanyClassification.vue?vue&type=script&lang=js"
export * from "./CompanyClassification.vue?vue&type=script&lang=js"
import style0 from "./CompanyClassification.vue?vue&type=style&index=0&id=cd2ea8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2ea8d6",
  null
  
)

export default component.exports